import type { Label } from "@kandoo/shared";
import { labelColor } from "../util/labelColors";

interface LabelChipProps {
  label: Label;
  /** Compact mode renders a short colored bar (used densely on card faces). */
  compact?: boolean;
  onClick?: () => void;
  title?: string;
}

/** A colored label pill. In compact mode with no name it shrinks to a bar. */
export function LabelChip({ label, compact, onClick, title }: LabelChipProps) {
  const c = labelColor(label.color);
  const Tag = onClick ? "button" : "span";
  return (
    <Tag
      {...(onClick ? { type: "button" as const, onClick } : {})}
      title={title ?? label.name ?? c.label}
      className={`inline-flex items-center rounded ${c.chip} ${
        compact
          ? label.name
            ? "h-4 px-1.5 text-[10px] font-medium leading-none"
            : "h-2 w-8 px-0"
          : "px-2 py-0.5 text-xs font-medium"
      }`}
    >
      {(!compact || label.name) && (label.name || " ")}
    </Tag>
  );
}
